import { z } from 'zod';
import { EMAIL_TOO_LONG_MESSAGE, MAX_EMAIL_LENGTH } from './validation.js';
// FR02 (20261002_Odlozene_P3/003_Auth, OD-043 / AUD-016): identitní e-mail osoby (přihlašovací
// účet, svěřenec, zástupce, trenér, platformní uživatel, vlastník akademie) se na vstupu ořízne
// a převede na malá písmena. DB unikátnost (`users_email_lower_unique_idx`,
// `platform_users_email_lower_unique_idx`) i lookupy pracují nad `lower(email)`, takže
// `Jana@x.cz` a `jana@x.cz` jsou jedna schránka. Kontaktní e-maily akademie a testovací adresa
// pro e-maily nejsou identita a tímto schématem neprocházejí.
export const EMAIL_INVALID_MESSAGE = 'Zadejte platnou e-mailovou adresu.';
/**
 * Normalizace identitního e-mailu mimo Zod (CLI skripty, seed) - stejné pravidlo jako
 * `emailInputSchema`. Syntaxi neověřuje.
 */
export function normalizeEmailInput(value) {
    return value.trim().toLowerCase();
}
/**
 * Sdílené vstupní schéma identitního e-mailu. Pořadí je závazné: normalizace (`trim`,
 * `toLowerCase`) před syntaktickou kontrolou a délkovým limitem, aby se obojí měřilo nad
 * uloženou hodnotou. `.email()` Zodu přijímá jen ASCII adresy, takže `toLowerCase()` v JS
 * a `lower()` v Postgresu dávají pro přijaté hodnoty stejný výsledek.
 */
export const emailInputSchema = z
    .string()
    .trim()
    .toLowerCase()
    .email(EMAIL_INVALID_MESSAGE)
    .max(MAX_EMAIL_LENGTH, EMAIL_TOO_LONG_MESSAGE);
